/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_In_TimezoneInputs */



/**
* | output |
* | --- |
* | "in your timezone" |
*
* @param {Tournament_In_TimezoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_in_timezone = /** @type {((inputs?: Tournament_In_TimezoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_In_TimezoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("dans votre fuseau horaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("en su zona horaria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("no seu fuso horário")
	if (locale === "it") return /** @type {LocalizedString} */ ("nel tuo fuso orario")
	return /** @type {LocalizedString} */ ("in your timezone")
});